// Sweden's 21 län with their SCB code. Every kommun and RegSO code starts with its län's code, so a län's
// areas are the RegSO ids with that prefix. Used by kartvy's and listvy's search and the saved picks.

export const LAN_LIST = [
    { code: '01', name: 'Stockholm', label: 'Stockholms län' },
    { code: '03', name: 'Uppsala', label: 'Uppsala län' },
    { code: '04', name: 'Södermanland', label: 'Södermanlands län' },
    { code: '05', name: 'Östergötland', label: 'Östergötlands län' },
    { code: '06', name: 'Jönköping', label: 'Jönköpings län' },
    { code: '07', name: 'Kronoberg', label: 'Kronobergs län' },
    { code: '08', name: 'Kalmar', label: 'Kalmar län' },
    { code: '09', name: 'Gotland', label: 'Gotlands län' },
    { code: '10', name: 'Blekinge', label: 'Blekinge län' },
    { code: '12', name: 'Skåne', label: 'Skåne län' },
    { code: '13', name: 'Halland', label: 'Hallands län' },
    { code: '14', name: 'Västra Götaland', label: 'Västra Götalands län' },
    { code: '17', name: 'Värmland', label: 'Värmlands län' },
    { code: '18', name: 'Örebro', label: 'Örebro län' },
    { code: '19', name: 'Västmanland', label: 'Västmanlands län' },
    { code: '20', name: 'Dalarna', label: 'Dalarnas län' },
    { code: '21', name: 'Gävleborg', label: 'Gävleborgs län' },
    { code: '22', name: 'Västernorrland', label: 'Västernorrlands län' },
    { code: '23', name: 'Jämtland', label: 'Jämtlands län' },
    { code: '24', name: 'Västerbotten', label: 'Västerbottens län' },
    { code: '25', name: 'Norrbotten', label: 'Norrbottens län' },
];

const normalizeLan = (value) => String(value || '').toLowerCase().replace(/\s+län$/, '').replace(/\s+/g, ' ').trim();

// 'Stockholm', 'Stockholms län' or '01' → its LAN_LIST entry, else null.
export const findLan = (value) => {
    const text = normalizeLan(value);
    if (!text) return null;
    if (/^\d{1,2}$/.test(text)) return LAN_LIST.find((lan) => lan.code === text.padStart(2, '0')) || null;
    const bare = text.endsWith('s') ? text.slice(0, -1) : text;
    return LAN_LIST.find((lan) => {
        const name = lan.name.toLowerCase();
        return name === text || name === bare;
    }) || null;
};

// The RegSO ids of a län among the given ids.
export const regsoIdsInLan = (code, regsoIds) => (Array.isArray(regsoIds) ? regsoIds : [])
    .filter((id) => String(id || '').startsWith(code));
